import EditablePropsType from '../../../types/composer';

export const subtitleSchema = {
  type: EditablePropsType.Text,
  label: 'Subtitle',
  name: 'subtitle',
};

export default subtitleSchema;
